
import { EntityService } from '@/services/entity.service'
import Vue from 'vue'
import New from './New.vue'
import Edit from './Edit.vue'

const entityService = new EntityService()

export default Vue.extend({
  name: 'UsersList',
  components: {
    New,
    Edit
  },
  data: () => ({
    entity: 'users',
    search: '',
    listData: [],
    headers: [
      {
        text: 'Nombre',
        value: 'firstName'
      },
      {
        text: 'Email',
        value: 'email'
      },
      {
        text: 'Tipo de Usuario',
        value: 'type'
      },
      {
        text: 'Fecha Creación',
        value: 'createdAt'
      },
      {
        text: '',
        value: 'actions',
        align: 'right'
      }
    ],
    showModalNew: false,
    showModalEdit: false,
    editEntity: {}
  }),
  async created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.listData = await entityService.getList(this.entity)
    },
    getStatusLabelColor (status: string) {
      switch (status) {
        case 'admin':
          return {
            label: 'Administrador',
            color: '#13DEB9FF'
          }
        case 'user':
          return {
            label: 'Usuario',
            color: '#49BEFFFF'
          }
        default:
          return {
            label: '',
            color: ''
          }
      }
    },
    editEntityAction (entity: object) {
      this.editEntity = entity
      this.showModalEdit = true
    }
  },
  watch: {
    showModalNew (value) {
      if (!value) this.loadData()
    },
    showModalEdit (value) {
      if (!value) this.loadData()
    }
  }
})
